/// <reference path="../../references.ts" />

/* @ngInject */
export default function htmlSafeFilterFactory($sce): ng.IFilterService {
	return function(htmlCode) {
		return $sce.trustAsHtml(htmlCode);
	};
}
